import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

/**
 * Shows the per-view / measure / relationship counts returned by
 * POST /api/semantic/import-lookml, plus any non-fatal parse warnings.
 */
export function LookmlSummaryDialog({ result, onClose }) {
  return (
    <Dialog open={!!result} onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent className="glass-card border-border/50 rounded-2xl sm:max-w-lg" data-testid="lookml-summary-dialog">
        <DialogHeader><DialogTitle className="font-heading">LookML Import Complete</DialogTitle></DialogHeader>
        {result && (
          <div className="space-y-3 mt-2 text-xs">
            <div className="p-3 rounded-lg border border-emerald-500/20 bg-emerald-500/5">
              <p className="font-heading font-semibold text-emerald-400 mb-2">{result.model?.name}</p>
              <div className="grid grid-cols-2 gap-2 text-muted-foreground">
                <div>Views: <span className="text-foreground font-mono">{result.summary?.views_imported}</span></div>
                <div>Attributes: <span className="text-foreground font-mono">{result.summary?.dimensions_imported}</span></div>
                <div>Measures: <span className="text-foreground font-mono">{result.summary?.measures_imported}</span></div>
                <div>Relationships: <span className="text-foreground font-mono">{result.summary?.relationships_imported}</span></div>
              </div>
            </div>
            {result.summary?.parse_errors?.length > 0 && (
              <div className="p-2.5 rounded-lg border border-amber-500/20 bg-amber-500/5">
                <p className="text-[10px] font-heading font-semibold text-amber-400 mb-1">Parse Warnings ({result.summary.parse_errors.length})</p>
                <ul className="space-y-0.5 max-h-24 overflow-auto">
                  {result.summary.parse_errors.slice(0, 8).map((err, i) => <li key={i} className="text-[10px] text-amber-400/80">{err}</li>)}
                </ul>
              </div>
            )}
            <Button onClick={onClose} className="w-full rounded-lg" data-testid="lookml-summary-close">Close</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
